import React, { useState } from "react";

const Item = ({ header, photo, content, defaultOpen }) => {
  const [isOpen, setIsOpen] = useState(!!defaultOpen);
  const toggleOpen = () => setIsOpen((v) => !v);

  return (
    <div
      className={`job-card${isOpen ? " open" : ""}`}
      title="Klik om te openen"
      onClick={toggleOpen}
    >
      <div className="job-card-head">
        <img className="job-logo" src={photo} alt={header.where} />
        <div className="job-headline">
          <div className="job-title">{header.title}</div>
          <div className="job-company">
            {header.where} · {header.employmentType}
          </div>
        </div>
        <div className="job-years">
          {header.from} – {header.to}
        </div>
        <span className="job-toggle">+</span>
      </div>
      {isOpen && <div className="job-body">{content}</div>}
    </div>
  );
};

export default Item;
